module.exports = __webpack_public_path__ + "img/background066.jpg";